<ng-container [formGroup]="form">
  <mat-form-field [attr.data-test-id]="config.testId"
                  class="form-input">
    <mat-label>{{config.title}}</mat-label>
    <input [formControlName]="controlName"
           [textMask]="config.textMask"
           type="tel"
           phone
           autocomplete="off"
           matInput
           [placeholder]="config.placeholder">
    <button (click)="clearField(control, $event)"
            *ngIf="control?.value"
            aria-label="Clear"
            class="p-0"
            mat-button
            mat-icon-button
            matSuffix>
      <mat-icon>close</mat-icon>
    </button>
    <mat-error>{{getError(control, config.errors)}}</mat-error>
  </mat-form-field>
</ng-container>
